'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { useState } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Sow_Deliverable } from '@/modules/__generated__/graphql/switchboard-generated';
import type { WorkstreamDetailsProject } from '@/modules/project/types';
import { useInfiniteArray } from '@/modules/shared/hooks/use-infinite-array';
import { getProjectByDeliverableId } from '@/modules/workstream/lib/utils';
import { createDeliverableTitle } from '../../lib/deliverable-helpers';
import { ProposalApplyCard } from './proposal-apply-card';
interface ProposalCardsGridProps {
  deliverables: Array<Pick<Sow_Deliverable, 'id' | 'code' | 'title' | 'description'>>;
  shouldUsePagination?: boolean;
  projects: WorkstreamDetailsProject[];
  networkSlug: string;
  workstreamSlug: string;
}
function ProposalCardsGrid(t0) {
  const $ = _c(35);
  const {
    deliverables,
    shouldUsePagination: t1,
    projects,
    networkSlug,
    workstreamSlug
  } = t0;
  const shouldUsePagination = t1 === undefined ? true : t1;
  const [, setActiveIndex] = useState(0);
  let t2;
  if ($[0] !== shouldUsePagination) {
    t2 = {
      firstPageSize: 6,
      pageSize: 9,
      enabled: shouldUsePagination
    };
    $[0] = shouldUsePagination;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    visibleItems,
    hasMore,
    loadMore
  } = useInfiniteArray(deliverables, t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [Navigation];
    t4 = swiper => {
      setActiveIndex(swiper.activeIndex);
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== deliverables || $[5] !== networkSlug || $[6] !== projects || $[7] !== workstreamSlug) {
    let t6;
    if ($[9] !== networkSlug || $[10] !== projects || $[11] !== workstreamSlug) {
      t6 = deliverable => {
        const projectDetails = getProjectByDeliverableId(deliverable.id, projects);
        return <SwiperSlide key={deliverable.id}><div className="h-38 px-5 pb-2 sm:h-35.5 sm:px-10 [&>*:first-child]:h-full"><ProposalApplyCard key={deliverable.id} title={createDeliverableTitle(deliverable.code, deliverable.title)} description={deliverable.description} tags={[]} project={projectDetails} networkSlug={networkSlug} workstreamSlug={workstreamSlug} /></div></SwiperSlide>;
      };
      $[9] = networkSlug;
      $[10] = projects;
      $[11] = workstreamSlug;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = deliverables.map(t6);
    $[4] = deliverables;
    $[5] = networkSlug;
    $[6] = projects;
    $[7] = workstreamSlug;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div className="md:hidden"><Swiper navigation={true} modules={t3} onSlideChange={t4}>{t5}</Swiper></div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== networkSlug || $[16] !== projects || $[17] !== visibleItems || $[18] !== workstreamSlug) {
    let t8;
    if ($[20] !== networkSlug || $[21] !== projects || $[22] !== workstreamSlug) {
      t8 = deliverable_0 => {
        const projectDetails_0 = getProjectByDeliverableId(deliverable_0.id, projects);
        return <ProposalApplyCard key={deliverable_0.id} title={createDeliverableTitle(deliverable_0.code, deliverable_0.title)} description={deliverable_0.description} tags={[]} project={projectDetails_0} networkSlug={networkSlug} workstreamSlug={workstreamSlug} />;
      };
      $[20] = networkSlug;
      $[21] = projects;
      $[22] = workstreamSlug;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t7 = visibleItems.map(t8);
    $[15] = networkSlug;
    $[16] = projects;
    $[17] = visibleItems;
    $[18] = workstreamSlug;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-4 xl:grid-cols-3 xl:gap-6">{t7}</div>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== hasMore || $[27] !== loadMore) {
    t9 = hasMore && <div className="flex justify-center pt-2"><Button variant="outline" onClick={loadMore}>Load More</Button></div>;
    $[26] = hasMore;
    $[27] = loadMore;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9) {
    t10 = <div className="hidden flex-col gap-4 md:flex">{t8}{t9}</div>;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t6) {
    t11 = <>{t6}{t10}</>;
    $[32] = t10;
    $[33] = t6;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}
export { ProposalCardsGrid };